import { IFormsTemplate } from '@commenda/api';
import { Badge } from '@commenda/kakashi';
import { FormsTemplateStatus } from '@commenda/types';
import { cn } from '@commenda/utils';
import { useDraggable } from '@dnd-kit/core';
import { Layers } from 'lucide-react';

interface DraggableSavedModuleProps {
  module: IFormsTemplate;
}

export default function DraggableSavedModule({
  module,
}: DraggableSavedModuleProps) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `saved-module-${module.id}`,
    data: {
      type: 'saved-module',
      moduleId: module.id,
      moduleName: module.name,
      moduleData: module,
    },
  });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className={cn(
        'flex items-center gap-3 p-3 rounded-lg border border-border-secondary',
        'bg-bg-primary hover:bg-bg-secondary cursor-grab active:cursor-grabbing',
        'transition-all duration-150',
        isDragging && 'opacity-50 shadow-lg ring-2 ring-border-brand'
      )}
    >
      <div className="flex items-center justify-center w-8 h-8 rounded-md bg-bg-tertiary">
        <Layers className="w-4 h-4 text-text-secondary" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <p className="txt-small-medium text-text-primary truncate">
            {module.name}
          </p>
          <Badge
            size="sm"
            variant={
              module.status === FormsTemplateStatus.LIVE ? 'success' : 'gray'
            }
          >
            {module.status === FormsTemplateStatus.LIVE ? 'Live' : 'Completed'}
          </Badge>
        </div>
        {module.description && (
          <p className="txt-xs-regular text-text-tertiary truncate">
            {module.description}
          </p>
        )}
      </div>
    </div>
  );
}
